// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"InspectTable_tableContainer__nyM3z","tableTitle":"InspectTable_tableTitle__Z8zgg","table":"InspectTable_table__3S4kn"};